<!-- @bad TODO: Keyboard navigation-->
<tui-hosted-dropdown
    *tuiLet="backgroundColor$ | async as selectedColor"
    #hilite
    [content]="hiliteDropdown"
    [tuiDropdownMaxHeight]="999"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        tuiHintDirection="top-left"
        appearance="icon"
        icon="tuiIconHiliteLarge"
        automation-id="toolbar__hilite-button"
        tuiHintDescribe
        class="t-tool"
        [tuiHint]="backColorText$ | async"
        [pseudoActive]="hilite.open"
        [focusable]="hilite.open"
    ></button>
    <div
        *ngIf="!isBlankColor(selectedColor || '')"
        class="t-plate"
        [style.background]="selectedColor"
    ></div>
    <ng-template
        #hiliteDropdown
        let-activeZone
    >
        <tui-palette
            class="t-color-picker"
            [tuiActiveZoneParent]="activeZone"
            [colors]="colors"
            (selectedColor)="editor.setBackgroundColor($event)"
        ></tui-palette>
    </ng-template>
</tui-hosted-dropdown>
